export const state = () => ({
    languages: [],
});

export const mutations = {
    setLanguages(state: any, payload: any) {
        state.languages = payload;
    },
};

export const getters = {
    getLanguages: (state: any) => state.languages,
};

export const actions = {
    async getLanguages(state: any) {
        if (!state.state.languages.length) {
            return new Promise((resolve, reject) => {
                this.$axios
                    .get(`/api/languages`)
                    .then((result) => {
                        state.commit('setLanguages', result.data);
                        resolve(result.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        }

        return new Promise((resolve, reject) => {
            resolve(state.state.languages);
        });
    },
};
